import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_612_1818)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.4152 24.5028C13.5477 24.5028 10.2229 22.3682 8.41357 19.2571H17.4152V15.7599H7.14701C7.05654 15.1922 6.96607 14.6018 6.96607 14.0114C6.96607 13.4209 7.05654 12.8305 7.14701 12.2628H17.4152V8.76562H8.41357C10.2229 5.6318 13.5477 3.51988 17.4152 3.51988C20.6947 3.51988 23.6123 5.04137 25.5121 7.4258L28 4.92783C25.4443 1.93026 21.6672 0.0227194 17.4152 0.0227194C11.58 1.0537e-05 6.58158 3.63342 4.52342 8.74291H0V12.2401H3.66397C3.59612 12.8305 3.48304 13.3982 3.48304 13.9887C3.48304 14.5791 3.59612 15.1695 3.66397 15.7372H0V19.2344H4.52342C6.6042 24.3666 11.58 27.9773 17.4378 27.9773C21.6898 27.9773 25.4669 26.0698 28.0226 23.0722L25.5347 20.5742C23.6123 22.9586 20.7173 24.4801 17.4378 24.4801L17.4152 24.5028Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_612_1818",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgFact;
